export type Locale = 'en' | 'pl' | 'es' | 'de'

export const locales: Locale[] = ['en', 'pl', 'es', 'de']
export const defaultLocale: Locale = 'en'
